import { useEffect, useState } from "react";

const COOKIE = "eigoo_consent";
const DAYS = 365;

function hasConsent() {
    if (typeof document === "undefined") return true;
    return document.cookie.split("; ").some((c) => c.startsWith(`${COOKIE}=true`));
}

function setConsent() {
    const d = new Date();
    d.setTime(d.getTime() + DAYS * 24 * 60 * 60 * 1000);
    document.cookie = `${COOKIE}=true; expires=${d.toUTCString()}; path=/; SameSite=Lax`;
}

export default function CookieShield() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!hasConsent()) {
            const t = setTimeout(() => setVisible(true), 600);
            return () => clearTimeout(t);
        }
    }, []);

    if (!visible) return null;

    const onAccept = () => {
        setConsent();
        setVisible(false);
    };

    return (
        <>
            <style>{`
                @keyframes eigooCookieFade {
                    from { opacity: 0; transform: translateY(16px); }
                    to   { opacity: 1; transform: translateY(0); }
                }
                #eigoo-cookie-shield {
                    position: fixed;
                    left: 12px;
                    right: 12px;
                    bottom: calc(16px + env(safe-area-inset-bottom, 0px));
                    z-index: 9999;
                    width: auto;
                    max-width: 920px;
                    margin: 0 auto;
                    background: #1a1a1a;
                    color: #e2e8f0;
                    border: 1px solid rgba(212, 175, 55, 0.35);
                    border-radius: 8px;
                    padding: 14px 18px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 14px;
                    box-shadow: 0 12px 40px rgba(0,0,0,0.6), 0 0 24px rgba(212,175,55,0.12);
                    font-family: "Inter", "Montserrat", ui-sans-serif, system-ui, sans-serif;
                    font-size: 13px;
                    line-height: 1.55;
                    animation: eigooCookieFade 0.5s ease-out both;
                    box-sizing: border-box;
                }
                #eigoo-cookie-shield p {
                    margin: 0;
                    flex: 1;
                    min-width: 0;
                    overflow-wrap: anywhere;
                }
                #eigoo-cookie-shield button {
                    flex-shrink: 0;
                    background: #d4af37;
                    color: #0a0e17;
                    border: 1px solid #d4af37;
                    padding: 10px 22px;
                    border-radius: 999px;
                    font-family: inherit;
                    font-size: 11px;
                    font-weight: 700;
                    letter-spacing: 0.24em;
                    text-transform: uppercase;
                    cursor: pointer;
                    transition: background-color 0.3s ease, box-shadow 0.3s ease;
                }
                #eigoo-cookie-shield button:hover {
                    background: #ffd37a;
                    box-shadow: 0 0 24px rgba(212,175,55,0.4);
                }
                @media (max-width: 640px) {
                    #eigoo-cookie-shield {
                        flex-direction: column;
                        align-items: stretch;
                        text-align: left;
                        padding: 14px 16px;
                    }
                    #eigoo-cookie-shield button {
                        width: 100%;
                    }
                }
            `}</style>
            <div
                id="eigoo-cookie-shield"
                role="dialog"
                aria-label="Cookie consent"
                data-testid="cookie-shield"
            >
                <p>
                    This site uses cookies to enhance your experience. By
                    continuing, you consent to our use of cookies.
                </p>
                <button
                    type="button"
                    onClick={onAccept}
                    data-testid="cookie-shield-accept"
                >
                    Got it
                </button>
            </div>
        </>
    );
}
